/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { Box, Skeleton, Stack } from "@mui/material";
import { Fetching } from "components/common/loading/fetching";
import { useHeatsData } from "components/strategyDashboard/heats/context/HeatsDataContext";
import { useHeatsFilter } from "./context/HeatsFilterContext";
import { HeatsSummaryItem } from "./heatsSummary/HeatsSummaryItem";
import { equalSets } from "./utils";

export const HeatsSummary = () => {
  const { data, isLoading, isFetching } = useHeatsData();
  const { ignoredMaterials } = useHeatsFilter();
  const items =
    data?.heats_summary?.items.filter(({ ignored_materials }) =>
      equalSets(ignoredMaterials, new Set(ignored_materials))
    ) ?? [];
  if (items.length === 0) {
    return null;
  }

  return (
    <Fetching fetching={isFetching} disableFullWidth>
      <Box
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          px: 2,
          py: 1.5,
          maxWidth: 1160,
          backgroundColor: "background.paper",
        }}
      >
        <Stack
          direction="row"
          spacing={4}
          alignItems="center"
          flexWrap="wrap"
          justifyContent="flex-end"
        >
          {isLoading ? (
            <>
              <Skeleton variant="text" width={120} />
              <Skeleton variant="text" width={80} />
            </>
          ) : (
            items.map((item) => (
              <HeatsSummaryItem key={item.summary_name} item={item} />
            ))
          )}
        </Stack>
      </Box>
    </Fetching>
  );
};
